import { videoPreviewOptions } from "../../new-boost/js/video/videoPreviewOptions";
import { cartSummaryOptions } from "./CartSummaryOptions";
import { createSlidesArrayFromJSON } from "../../new-boost/js/video/createSlidesArrayFromJSON";
import { CreateVideoPreviewSlides } from "../../new-boost/js/video/createVideoPreviewSlides";
import { VideoPreviewSlideShow } from "../../new-boost/js/video/videoPreviewSlideShow";
import { getVideoSlidesFromDOM } from "../../new-boost/js/video/getVideoSlidesFromDOM";

export class CartSummary {
    constructor() {
        if (jQuery(cartSummaryOptions.thisIsCartSummaryHandler).length > 0) {
            this.init();
        }
    }

    init() {
        let json = getVideoSlidesFromDOM();

        if (json) {
            // Format array from json blob
            let slideImagesArray = createSlidesArrayFromJSON(json);

            // create the slides
            new CreateVideoPreviewSlides(slideImagesArray);

            this.videoSlideShow = new VideoPreviewSlideShow(
                jQuery(videoPreviewOptions.handlers.videoSlideShowHandler)
            );
            jQuery(videoPreviewOptions.handlers.videoSlideShowHandler)
                .show()
                .addClass(
                    videoPreviewOptions.classes.videoSlideShowExtraMargin
                );
            jQuery(cartSummaryOptions.adPreviewImageHandler).hide();
        }
    }
}
